import React, { Component } from 'react';
import Select from 'react-select';
import MediaQuery from 'react-responsive';
import SocialMediaShareLinks from '../SocialMediaShareLinks/socialMediaShareLinks';
import AmazonImg from './Amazon-Store-250x85.png';
import AppleImg from './App-Store-250x85.gif';
import GoogleImg from './Google-Play-250x85.gif';

import './contact-us.css';

function buttonSubscribeClick() {
    window.open('https://go.bain.com/subscribe.html', '_blank');
}

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

class ContactUs extends Component {

    constructor(props) {
        super();
        this.state = {
            options: props.jsonConfig.industries.map((value) => { return { value, label: value }; }),
            industryStyle: {
                borderBottom: '#ccc',
            },
            selectedOption: null,
            selectedEmail: null,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    buttonGetInTouchClick() {
        const { selectedEmail } = this.state;
        let { selectedOption } = this.state;
        if(selectedOption) {
            selectedOption = encodeURIComponent(selectedOption);
        }
        const contactUsLink = `https://www.bain.com/about/contact-us/contact-form-page/?mReasonforcontactingBain=Business+inquiry%3A+I%E2%80%99m+exploring+hiring+Bain&m_Industry=${selectedOption}&Email=${selectedEmail}`;
        if(validateEmail(selectedEmail) && selectedOption) {
            window.open(contactUsLink, '_blank');
        } else {
            const email = document.getElementsByClassName('email-statement')[0];
            const industry = document.getElementsByClassName('react-select__control');
            if(!selectedEmail) {
                email.style.border = '1px solid #cb0000';
            }
            if(!selectedOption) {
                industry[0].style.border = '1px solid #cb0000'
            }
        }
    }

    handleChange(selectedOption) {
        const industry = document.getElementsByClassName('react-select__control');
        industry[0].style.border = 'none';
        industry[0].style.borderBottom = '1px solid #cb0000';
        this.setState({ selectedOption: selectedOption.value });
    };

    handleEmailChange(e) {
        if(validateEmail(e.target.value)) {
            e.target.style.border = '1px solid #000';
        } else {
            e.target.style.border = '1px solid #cb0000';
        }
        this.setState({ selectedEmail: e.target.value });
    };

    render() {
        return (
            <div className="GetInTouch-container">
                {/* <div className="background-with-centered-text">
                    <div className="text-wrap">
                        <h2>Start the conversation with Bain Digital</h2>
                        <p>To go deeper on your digital journey, contact us about applying the Bain Digital 360 Scorecard to your business.</p>
                        <button id="btnGetInTouch" className="button-start" onClick={this.buttonGetInTouchClick}>Get in touch</button>
                    </div>
                </div> */}
                <div className="contactus-section">
                    <div className="contactus-section-left">
                        <div className="question text">
                            Want to continue the conversation?
                        </div>
                        <div className="middle text">
                            Speak to our experts in
                        </div>
                        <div className="location">
                        <Select className='react-select-container' classNamePrefix="react-select" onChange={this.handleChange}
                            options={this.state.options} style={this.state.industryStyle} placeholder="Select an industry" />
                        {/* <select className="dropdown text">
                            <option value='' selected>Select an industry</option>
                            { this.props.jsonConfig.industries.map((value) => ( <option value={value}>{value}</option> )) }
                        </select> */}
                        </div>
                    </div>
                    <div className="contactus-section-right">
                    <div className="text statement">
                            We help global leaders with their organization{'\''}s most critical issues and opprtunities. Together, we create enduring change and results.
                        </div>
                        <div className="email-input">
                            <input type="email" className="email text statement email-statement" onChange={this.handleEmailChange.bind(this)} placeholder="Your work email address"/>
                        </div>
                        <div className="button">
                            <button type="button" onClick={this.buttonGetInTouchClick.bind(this)} className="button-start contact-button" value="Contact Us">Contact Us</button>
                        </div>
                    </div>
                </div>
                <div className="download-subscribe">
                    <div>
                        <h4>Download our Insights app</h4>
                        <ul className="download-list">
                            <li><a href="https://itunes.apple.com/us/app/bain-insights/id1103731219" target="_blank" rel="noopener noreferrer"><img src={AppleImg} className="appDownloadListImg" alt="Download on the App Store" /></a></li>
                            <li><a href="https://play.google.com/store/apps/details?id=com.bain.insights.mobile" target="_blank" rel="noopener noreferrer"><img src={GoogleImg} className="appDownloadListImg" alt="Get it on Google Play" /></a></li>
                            <li><a href="https://www.amazon.com/Bain-Company-Inc-Insights/dp/B01G2WF8EM/ref=sr_1_1?s=mobile-apps&ie=UTF8&qid=1464094956&sr=1-1&keywords=bain+insights&tag=cdigi-20" target="_blank" rel="noopener noreferrer"><img src={AmazonImg} className="appDownloadListImg" alt="Available on Amazon.com" /></a></li>
                        </ul>
                    </div>
                    <div>
                        <h4>Subscribe to our newsletter</h4>
                        <button id="btnSubscribe" type="button" className="button-start contact-button" onClick={buttonSubscribeClick}>Subscribe</button>
                    </div>
					<MediaQuery maxWidth={768}>
						<div>
							<h4 className="share-link">Share The Survey</h4>
                            <SocialMediaShareLinks jsonConfig={this.props.jsonConfig} />
                        </div>
					</MediaQuery>
                </div>
                <br /><br />
                <div className="copyright-container">
                    <p>&copy; 1996-2017. Bain &amp; Company</p>
                </div>
            </div>
        );
    }

}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/Results/contact-us.js